import styled from 'styled-components';

export const Wrapper = styled.div`
  box-shadow: 0 0.1rem 0.8rem 0 rgba(0, 0, 0, 0.5);
  border: 1px solid rgba(0, 0, 0, 0.4);
  flex: 1;
  height: 100%;
  max-width: 20%;

  @media (max-width: 768px) {
    max-width: 100%;
    width: 100%;
  }

  header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    padding: 1rem;

    border-bottom: 1px solid rgba(0, 0, 0, 0.4);

    color: #115293;

    .title {
      display: flex;
      align-items: center;
      margin-right: 1.5rem;

      svg {
        margin-right: 0.5rem;
      }

      h1 {
        font-size: 1rem;
        line-height: 1;
      }
    }

    @media (max-width: 768px) {
      padding: 0.75rem;

      .title {
        margin-right: 1rem;

        svg {
          font-size: 3rem;
        }

        h1 {
          font-size: 1.4rem;
          max-width: 15rem;
        }
      }
    }
  }
`;

export const Container = styled.div`
  height: calc(100% - 2rem - var(--header-height, 50px));
  flex: 1;
  display: flex;
  flex-direction: column;
  font-size: 1.2rem;
  align-items: stretch;
  align-self: strech;
  justify-content: space-between;

  color: #666;

  hgroup {
    display: flex;
    align-items: baseline;
    justify-content: center;
    padding: 1rem;
    color: #d32f2f;

    h1 {
      font-size: 2.5rem;
    }

    h2 {
      font-weight: 400;
      font-size: 2rem;
    }
  }
`;

export const WrapperLinhaVolumes = styled.div`
  display: flex;
  padding: 0 1rem;
  gap: 1rem;
  align-items: flex-start;
  align-self: stretch;
`;

export const WrapperVolume = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: center;
  gap: 0.2rem;
  color: #666;
`;

export const SeparadorVolumes = styled.div`
  width: 1px;
  align-self: stretch;
  background: #666;
`;

export const WrapperInfo = styled.div`
  flex: 1;
  display: flex;
  padding: 1rem;
  flex-direction: column;
  justify-content: space-between;
  align-items: stretch;
  align-self: stretch;
`;

export const LinhaIconeTexto = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  align-self: stretch;
`;
